import { doc, updateDoc } from 'firebase/firestore';
import React, { useState } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { db } from '../utils/firebase';
import toasted from '../config/toasted';
import { useUser } from '../context/UserContext';
import { formatDate } from '../utils/Universalfunctions';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { handleCancelSubscription } from '../utils/handleCancelSubscription';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { GeneratingTokens, Info } from '@mui/icons-material';
import { Offcanvas } from 'react-bootstrap';
import RazorpayPlans from '../Razorpays/RazorpayPlans';
import { loadRazorpayScript } from '../Razorpays/loadRazorpay';
import { currency } from '../config/config';

const Pricing = () => {

      const location = useLocation();
      const navigate = useNavigate();

      const queryParams = new URLSearchParams(location.search);
      const selectedIndex = queryParams.has('credits') ? 1 : 0;

      const handleTabSelect = (index) => {
            const path = index === 1 ? '?credits' : '?subscription';
            navigate(path, { replace: true });
      };

      const getPlanExpiryDate = (planTitle, planTimestamp) => {
            const startDate = new Date(planTimestamp);

            if (Number.isNaN(startDate.getTime())) return null;

            const expiryDate = new Date(startDate);

            if (planTitle === '7 Days') {
                  expiryDate.setDate(expiryDate.getDate() + 7);
            } else if (planTitle === '1 Month') {
                  expiryDate.setMonth(expiryDate.getMonth() + 1);
            } else if (planTitle === '3 Months') {
                  expiryDate.setMonth(expiryDate.getMonth() + 3);
            } else {
                  return null;
            }

            return expiryDate.toISOString();
      };



      const [open, setOpen] = useState(false);
      const [selectedPlan, setSelectedPlan] = useState(null);
      const { user, userData } = useUser();


      const pricingPlans = [
            {
                  id: "0",
                  tag: "STARTER",
                  type: "subscription",
                  title: "7 Days",
                  planId: 'plan_SQVZaaOCKoLxz4',
                  price: `${currency}149`,
                  duration: "/7 days",
                  credits: 150,
                  features: [
                        "Access all Premium Prompts",
                        "150 credits",
                        "Studio Mode access",
                        "Unlimited Likes & Bookmark",
                        "Submit Only Public Prompts",
                  ],
                  featuresNO: [
                        "Submit Exclusive Prompts ",
                  ],
                  featured: false
            },
            {
                  id: "1",
                  tag: "Pro Choice",
                  type: "subscription",
                  title: "1 Month",
                  planId: 'plan_SQVaTy51ilKv94',
                  badge: "CREATOR MODE",
                  price: `${currency}499`,
                  duration: "/ 1 month",
                  credits: 550,
                  features: [
                        "All Starter Features",
                        "550 credits",
                        "Eligible for Exclusive Prompts",
                        "Eligible for earning",
                        "<b>1 </b> withdrawals/month",
                        "Strictly <b>100% Original Content</b>",
                        "AI-driven dynamic payouts",
                        "Verified Creator Badge"
                  ],
                  featured: true
            },
            {
                  id: "2",
                  tag: "ENTERPRISE",
                  type: "subscription",
                  title: "3 Months",
                  planId: 'plan_SQVbKQLfadHIHj',
                  price: `${currency}799`,
                  duration: "/3 months",
                  credits: 1600,
                  features: [
                        "All Pro Choice Features",
                        "1600 credits",
                        "<b>AI Auto-Boost:</b> System boosts your prompts",
                        "<b>3 Withdrawals</b> month",
                        "Priority Review for submissions",
                        "Early access to new AI models",
                  ],
                  featured: false
            }
      ];


      // state for handling payment verification
      const [isVerifying, setIsVerifying] = useState(false);
      const [status, setStatus] = useState('');


      const handleVerify = async (plan) => {
            try {
                  setSelectedPlan(plan);

                  if (!user || !plan?.title || !plan?.price) {
                        toasted.error("Invalid transaction data");
                        return;
                  }

                  setIsVerifying(true);

                  const userRef = doc(db, "users", user.uid);
                  const planTimestamp = new Date().toISOString();
                  const expiryAt = getPlanExpiryDate(plan.title, planTimestamp);

                  const purchaseRecord = {
                        planTitle: plan.title,
                        amountPaid: plan.price,
                        credits: plan.credits,
                        planTimestamp,
                        expiryAt,
                        status: "success",
                        message: `${plan.title} plan activated successfully. Your subscription will remain active until ${expiryAt ? new Date(expiryAt).toLocaleDateString() : "N/A"}.`,
                  };

                  await updateDoc(userRef, {
                        generation_credits: (userData?.generation_credits || 0) + plan.credits,
                        message: `Your ${plan.title} subscription has been successfully activated. Enjoy premium access.`,
                        subscriptions: "paid",
                        isPremium: true,
                        planDetails: purchaseRecord,
                  });

                  setOpen(true);
                  setStatus("success");
                  toasted.success("Request sent successfully!");
            } catch (error) {
                  console.error("Payment error:", error);
                  setStatus("error");
            } finally {
                  setIsVerifying(false);
            }
      };




      const [loading, setLoading] = useState(false);

      const cancelSubscription = async () => {
            await handleCancelSubscription({
                  uid: userData?.uid,
                  setLoading,
                  onDone: () => toasted.success("Subscription Cancelled"),
                  onError: (e) => toasted.error(e?.message || "Cancel Failed"),
            });
      };

      const [loadingPlan, setLoadingPlan] = useState("");
      const API_BASE = "https://asia-south1-heyprompt-2d910.cloudfunctions.net";


      const handleSubscriptionPayment = async (plan) => {
            try {
                  setLoadingPlan(plan?.id);

                  if (!user) {
                        toasted.error("Please login first");
                        return;
                  }

                  const loaded = await loadRazorpayScript();
                  if (!loaded) {
                        toasted.error("Razorpay SDK failed to load");
                        return;
                  }

                  const token = await user?.getIdToken();

                  const res = await fetch(`${API_BASE}/createRazorpaySubscription`, {
                        method: "POST",
                        headers: {
                              "Content-Type": "application/json",
                              Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                              planId: plan.id,
                        }),
                  });

                  const data = await res.json();

                  if (!data.success) {
                        toasted.error(data.message || "Failed to create subscription");
                        return;
                  }

                  const options = {
                        key: data.key,
                        subscription_id: data.subscription.id,
                        name: "HeyPrompt",
                        description: plan.title,
                        image: "https://heyprompt.online/apple-touch-icon.png",
                        prefill: {
                              name: user?.displayName || user?.name || "",
                              email: user?.email || "",
                        },
                        theme: {
                              color: "#fff",
                              backdrop_color: "#fff",
                        },
                        handler: async function (response) {
                              console.log("Subscription success:", response);

                              await handleVerify(plan);
                              setSelectedPlan(plan)
                        },
                        modal: {
                              ondismiss: function () {
                                    console.log("Subscription modal closed");
                              },
                              backdropclose: false,
                              escape: true,
                              animation: true,
                        },
                  };

                  const rzp = new window.Razorpay(options);
                  rzp.open();
            } catch (error) {
                  console.error("Subscription payment error:", error);
                  toasted.error("Something went wrong");
            }
            finally {
                  setLoadingPlan("");
            }
      };


      const [showHistory, setShowHistory] = useState([]);
      const [show, setShow] = useState(false);

      const handleClose = () => setShow(false);
      const onCloseModal = () => setShow(false);

      const handleHistory = (data) => {
            setShow(true);
            setShowHistory(data)
      };



      return (
            <div className="pricing-section">
                  <div className="__container">
                        <Tabs
                              selectedIndex={selectedIndex}
                              onSelect={handleTabSelect}>


                              <div className="pricing-header">
                                    <span className="premium-pill">PRICING PLANS</span>
                                    <h1>Elevate Your <span className="gradient-text">Creative Workflow</span></h1>
                                    <p>
                                          Browse community prompts for free. Unlock the full potential of AI with
                                          our premium private library and advanced studio tools.
                                    </p>
                                    {isVerifying &&
                                          <p>
                                                please wait
                                          </p>
                                    }
                                    {status === 'success' && <p style={{ color: '#22c55e', marginTop: '10px' }}>Request Sent! We'll notify you soon.</p>}
                                    {userData?.subscriptions === 'payment_pending' && <p style={{ color: 'red', marginTop: '10px' }}>  Verifying your payment... This usually takes a few minutes. </p>}
                                    {userData?.subscriptions === 'cancel_user' && <p style={{ color: 'red', marginTop: '10px' }}> {userData?.name} {userData?.subscriptionMessage} </p>}
                                    {userData?.message && <p className='text-warning' style={{ marginTop: '10px' }}> {userData?.message} </p>}

                                    <TabList>
                                          <Tab> subscriptions </Tab>
                                          <Tab>Credits</Tab>
                                    </TabList>
                              </div>


                              <TabPanel>
                                    <div className="plans-grid">
                                          {userData?.subscriptions === "paid" ?
                                                <div className="active-plan-container">
                                                      <div className="active-plan-card">
                                                            <div className="card-header">
                                                                  <span className="status-badge">Current Active Plan</span>
                                                                  <p> {userData?.planDetails?.message} </p>
                                                            </div>

                                                            <div className="card-body">
                                                                  <h2 className="plan-name">{userData?.planDetails?.planTitle || "Premium Plan"} subscription Package</h2>
                                                                  <div className="plan-status">
                                                                        <span className="dot"></span> Active
                                                                  </div>

                                                                  <div className="plan-status">
                                                                        <Info /> Amount : {userData?.planDetails?.amountPaid || 0}
                                                                  </div>


                                                                  <div className="plan-status">
                                                                        <GeneratingTokens /> With Package Credits : {userData?.planDetails?.credits || 0}
                                                                  </div>

                                                                  {userData?.token_purchases?.length > 0 &&
                                                                        <div className="plan-status">
                                                                              <GeneratingTokens />Total Buy Credits : {userData?.token_purchases?.reduce((sum, item) => sum + (item?.credits || 0), 0)}
                                                                        </div>
                                                                  }

                                                                  <div className="plan-details">
                                                                        <div className="detail-item">
                                                                              <span className="icon">📅</span>
                                                                              <p>Expires on: <strong>{formatDate(userData?.planDetails?.expiryAt)}</strong></p>
                                                                        </div>
                                                                        <div className="detail-item">
                                                                              <span className="icon">🚀</span>
                                                                              <p>Access Level: <strong> {userData?.planDetails?.planTitle} Premium</strong></p>
                                                                        </div>
                                                                  </div>

                                                                  <div className='report-btn-sec'>
                                                                        {userData?.token_purchases?.length > 1 &&
                                                                              <button className='report-btn' type='button' onClick={() => handleHistory(userData?.token_purchases)}>
                                                                                    Buying Credit Reports
                                                                              </button>
                                                                        }
                                                                  </div>
                                                            </div>

                                                            <div className="card-footer">
                                                                  <Link to="/account" className="dashboard-btn">Go to Dashboard</Link>
                                                                  <button className="manage-btn" disabled={loading} onClick={cancelSubscription}>
                                                                        {loading ? "Cancelling..." : "Cancel Subscription"}
                                                                  </button>
                                                            </div>
                                                      </div>
                                                </div>
                                                :

                                                pricingPlans.map((plan, index) => (
                                                      <div key={index} className={`pricing-card ${plan.featured ? "is-featured" : ""}`}>
                                                            {plan.badge && <div className="popular-badge">{plan.badge}</div>}

                                                            <div className="card-top">
                                                                  <span className="plan-tag">{plan.tag}</span>
                                                                  <h3 className="plan-title">{plan.title}</h3>
                                                                  <p className="plan-desc">{plan.desc}</p>
                                                            </div>

                                                            <div className="plan-price">
                                                                  <span className="currency">{plan.price}</span>
                                                                  <span className="period">{plan.duration}</span>
                                                            </div>

                                                            <ul className="feature-list">
                                                                  {plan.features.map((feature, i) => (
                                                                        <li key={i}>
                                                                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                                              <span dangerouslySetInnerHTML={{ __html: feature }} />
                                                                        </li>
                                                                  ))}

                                                                  {plan?.featuresNO?.map((feature, i) => (
                                                                        <li key={i}>
                                                                              ❌ <span dangerouslySetInnerHTML={{ __html: feature }} />
                                                                        </li>
                                                                  ))}
                                                            </ul>

                                                            <button
                                                                  className="cta-button"
                                                                  onClick={() => handleSubscriptionPayment(plan)}
                                                                  disabled={userData?.subscriptions === "payment_pending"}
                                                            >
                                                                  {loadingPlan === plan.id ? "Processing..." : `Choose Plan`}
                                                            </button>



                                                            {user ? "" : <Link to="/login" className="login-link">Log in to subscribe</Link>}
                                                      </div>
                                                ))}
                                    </div>
                              </TabPanel>

                              <TabPanel>
                                    <RazorpayPlans
                                          userData={userData} />
                              </TabPanel>
                        </Tabs>




                        <div className="pricing-footer">
                              <p>💡 <b>Note:</b> You can upgrade, downgrade, or cancel your subscription at any time. No hidden fees.</p>
                        </div>
                  </div>


                  <Offcanvas show={show} onHide={handleClose} className="repor-offcanvas">
                        <Offcanvas.Header closeButton>
                              <Offcanvas.Title>Report </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                              <div className='table-responsive mb-0'>
                                    <table className='table table-hover mb-0'>
                                          <tbody>
                                                {showHistory?.map((item, i) => (
                                                      <tr key={i}>
                                                            <td>
                                                                  <div className='__item'>
                                                                        <p> Package:  </p>
                                                                        <p>  {item?.planTitle} </p>
                                                                  </div>
                                                                  <div className='__item'>
                                                                        <p>  Credits: </p>
                                                                        <p> {item?.credits}  </p>
                                                                  </div>
                                                                  <div className='__item'>
                                                                        <p> Amount  </p>
                                                                        <p>  {item?.amountPaid}  </p>
                                                                  </div>
                                                                  <div className='__item'>
                                                                        <p>  Time </p>
                                                                        <p>  {item?.planTimestamp} </p>
                                                                  </div>
                                                                  <div className='__item'>
                                                                        <p>Approved / status  </p>
                                                                        <p>  By System / <span className={`badge rounded-pill text-bg-${item?.status === 'paid' ? 'success' : 'danger' || item?.status === 'success' ? 'success' : 'danger'} `}> {item?.status?.toUpperCase()}</span> </p>
                                                                  </div>
                                                            </td>
                                                      </tr>
                                                ))}

                                          </tbody>
                                    </table>
                              </div>
                        </Offcanvas.Body>
                  </Offcanvas>


                  <Modal open={open} onClose={() => onCloseModal()} center classNames={{ modal: 'customModal congratulations-modal' }}>

                        <div className="checkout-container">
                              <h2>🎉 Congratulations!</h2>
                              <p className="plan-info">Plan: <b>{selectedPlan?.title}</b> is Active NoW </p>
                              <p className="payment-apps-note">
                                    Your payment request has been received successfully.
                              </p>
                              <div className="payment-form mt-3">
                                    <Link className="submit-btn" to="/submit">
                                          submit Your Art
                                    </Link>

                                     <Link className="submit-btn" to="/ai-image-generator">
                                          AI Image Generator
                                    </Link>
                              </div>
                        </div>

                  </Modal>



            </div>
      );
};

export default Pricing;